import { StrictMode } from "react"

import { QueryClientProvider } from "@tanstack/react-query"

import { IDirective } from "angular"
import { createRoot } from "react-dom/client"

import { queryClient } from "@/query/queryClient"

import { AssignmentWizard } from "./AssignmentWizard"
import { AssignmentWizardController } from "./AssignmentWizard.controller"

export function AssignmentWizardDirective(): IDirective {
  return {
    restrict: "E",
    controller: "AssignmentWizardController",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])

      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <AssignmentWizard
              controller={controller as AssignmentWizardController}
            />
          </QueryClientProvider>
        </StrictMode>,
      )

      // Clean up React component when the Angular component is destroyed
      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
